// Count of in-flight authAxios requests. The service worker update flow
// consults this so a deferred reload never tears the page down while a
// mutation the user just submitted is still on the wire.
let pending = 0;

export const trackRequest = (): void => {
  pending += 1;
};

export const untrackRequest = (): void => {
  pending = Math.max(0, pending - 1);
};

export const hasPendingRequests = (): boolean => pending > 0;
